<app-common-header title="" [hasCloseButton]="false" [hasMenu]="false"></app-common-header>
<div class="text-center my-5" data-cy="DIV-00a9">
  <img class="mt-5 mb-3" src="assets/images/icon-success.svg" />
  <h3 class="my-4" [innerHTML]="'ATS_INTERVIEW_INVITATION_SUCCESS' | translate" data-cy="H3-aff3"></h3>
</div>
